import * as mui from '@mui/material'
import React from 'react'
import {useField, useFormikContext} from 'formik'
import {valuesType} from 'utils/values'


export function ToggleButton(props: {
  name: string,
  label: React.ReactNode,
  calculate: (values: valuesType) => void,
  sx?: mui.SxProps<mui.Theme>
}) {
  const { values } = useFormikContext()
  const [field, , helpers] = useField(props.name)

  return (
    <mui.ToggleButton
      value="check"
      onChange={() =>
        helpers.setValue(!field.value)
          .then(() => props.calculate({
            ...values as valuesType,
            [props.name]: !field.value,
          }))}
      selected={field.value}
      sx={{
        borderRadius: '6px',
        border: 0,
        px: 3,
        py: 2,
        textTransform: 'none',
        '&.Mui-selected:not(:hover)': {},
        ...props.sx,
      }}
    >
      <mui.Box>{props.label}</mui.Box>
    </mui.ToggleButton>
  )
}
